// Function loadSiteFooter loads the SiteFooter class by dynamically importing the js on demand if needed

export function loadSiteFooter($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-site-footer-chunk" */ '../widgets/siteFooter').then(wg => {

		const { SiteFooter } = wg;

		let $wg = $parentEl.querySelector('[data-wg="SiteFooter"]');

		if(!$wg) {
			// console.info('SiteFooter: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SiteFooter"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new SiteFooter($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SiteFooter($wg);
		}


	}).catch(error => error+'An error occurred while loading the SiteFooter widget');

}
